import { createMongoAbility } from '@casl/ability';
import { createContext } from 'react';

export const ability = createMongoAbility([]);

export function updateAbility(abilities) {
	ability.update(abilities);
}

export const AbilityContext = createContext(ability);
